import {
  getProfileApi,
  updateProfileApi,
  changePasswordApi,
  deleteUserApi,
} from './users.api';

export const getProfileReducers = (builder) => {
  builder
    .addCase(getProfileApi.pending, (state) => {
      state.getProfileStatus = 'pending';
    })
    .addCase(getProfileApi.fulfilled, (state, { payload }) => {
      state.user = payload;
      state.userId = payload._id;
      state.getProfileStatus = 'successful';
    })
    .addCase(getProfileApi.rejected, (state, { payload }) => {
      state.getProfileStatus = 'failed';
      state.error = payload?.message || 'Failed to fetch profile';
    });
};

export const updateProfileReducers = (builder) => {
  builder
    .addCase(updateProfileApi.pending, (state) => {
      state.updateProfileStatus = 'pending';
    })
    .addCase(updateProfileApi.fulfilled, (state, { payload }) => {
      state.user = payload;
      state.updateProfileStatus = 'successful';
    })
    .addCase(updateProfileApi.rejected, (state, { payload }) => {
      state.updateProfileStatus = 'failed';
      state.error = payload?.message || 'Failed to update profile';
    });
};

export const changePasswordReducers = (builder) => {
  builder
    .addCase(changePasswordApi.pending, (state) => {
      state.changePasswordStatus = 'pending';
    })
    .addCase(changePasswordApi.fulfilled, (state) => {
      state.changePasswordStatus = 'successful';
    })
    .addCase(changePasswordApi.rejected, (state, { payload }) => {
      state.changePasswordStatus = 'failed';
      state.error = payload?.message || 'Failed to change password';
    });
};

export const deleteUserReducers = (builder) => {
  builder
    .addCase(deleteUserApi.pending, (state) => {
      state.deleteUserStatus = 'pending';
    })
    .addCase(deleteUserApi.fulfilled, (state) => {
      state.deleteUserStatus = 'successful';
    })
    .addCase(deleteUserApi.rejected, (state, { payload }) => {
      state.deleteUserStatus = 'failed';
      state.error = payload?.message || 'Failed to delete user';
    });;
};
